import $ from 'jquery';
import PlayIcon from '../../../assets/svg/textToVideo/video-controls-paly.svg?react';
import StopIcon from '../../../assets/svg/textToVideo/video-controls-stop.svg?react';
import VideoPlayIcon from '../../../assets/svg/textToVideo/video-play-preview.svg?react';
import styles from './FJMediaPreview.module.less';
import FJUtil from '../../../util/FJUtil';
import classNames from 'classnames';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import FJSlider from '../../../common/components/FJSlider/FJSlider';
import FJRetry from '../../../common/components/FJRetry/FJRetry';
import FJLoading from '../../../common/components/FJLoading/FJLoading';
import { FJ_EVENT_TYPE } from '../../../constants/FJEvenTypeConstant';
import PropTypes from 'prop-types';
import FJEvent from '../../../store/FJEvent';

let _isBindEvent = false;
let _timer = null;
let _keyDownTimeStamp = 0;
let _curTarget = null;
const FJMediaPreview = props => {
    const { closePanel, mediaPreviewData } = props;
    let {
        type: mediaType,
        url: mediaUrl,
        timeData,
        duration = 0,
        viewSize = { width: 320, height: 320 },
        active,
        position,
        target,
    } = mediaPreviewData;
    const [mediaSize, setMediaSize] = useState(viewSize);
    const [progress, setProgress] = useState(0);
    const [url, setUrl] = useState(mediaUrl);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isRetry, setIsRetry] = useState(false);
    const isPlayingBeforeSeekRef = useRef(false);
    const isDraggingRef = useRef(false);
    const videoRef = useRef(null);
    const isLoadedRef = useRef(false);
    const audioRef = useRef(null);
    const viewRef = useRef(null);
    if (timeData) {
        duration = timeData.endTime - timeData.startTime;
    }
    const init = () => {
        _curTarget = target;
        setProgress(0);
        setIsPlaying(false);
        setIsLoading(true);
        setIsRetry(false);
        isPlayingBeforeSeekRef.current = false;
        isDraggingRef.current = false;
        isLoadedRef.current = false;
        setUrl(mediaUrl);
        setMediaSize(viewSize);
    };
    useEffect(() => {
        _pause();
        if (active) {
            init();
        } else {
            setUrl('');
        }
    }, [active, mediaUrl]);
    useEffect(() => {
        if (active) {
            _bindMouseEvent();
        } else {
            _unbindMouseEvent();
        }
        return () => {
            _unbindMouseEvent();
        };
    }, [active, isPlaying]);

    useEffect(() => {
        return FJEvent.subscribe(FJ_EVENT_TYPE.UPDATE_MEDIA_PREVIEW_TIME, data => {
            if (mediaRef.current && active) {
                mediaRef.current.currentTime = data;
            }
        });
    }, [active]);
    useEffect(() => {
        return FJEvent.subscribe(FJ_EVENT_TYPE.UPDATE_MEDIA_PREVIEW_PLAYING, data => {
            if (mediaRef.current && active && data !== isPlaying) {
                _triggerController(null, data);
            }
        });
    }, [active, isPlaying]);
    useEffect(() => {
        return FJEvent.subscribe(FJ_EVENT_TYPE.UPDATE_MEDIA_PREVIEW_DRAGGING, data => {
            if (data === isDraggingRef.current) return;
            isDraggingRef.current = data;
        });
    }, []);
    const isCanControl = useMemo(() => {
        return mediaType === 'VIDEO' || mediaType === 'AUDIO';
    }, [mediaType]);
    const _mouseDown = e => {
        // 判断是否点击了menu的区域
        let p = {
            x: e.clientX,
            y: e.clientY,
        };

        let p1 = $(viewRef.current).position();
        let s = {
            width: viewRef.current.offsetWidth,
            height: viewRef.current.offsetHeight,
        };
        if (_curTarget == e.target) return;
        if (p.x >= p1.left && p.x <= p1.left + s.width && p.y >= p1.top && p.y <= p1.top + s.height) {
            return;
        } else {
            closePanel();
        }
    };
    const _bindMouseEvent = () => {
        if (_isBindEvent) {
            _unbindMouseEvent();
        }
        _isBindEvent = true;
        document.body.addEventListener('mousedown', _mouseDown);
        window.addEventListener('resize', closePanel);
        window.addEventListener('keydown', _keyDown);
    };
    const _unbindMouseEvent = () => {
        if (!_isBindEvent) return;
        _isBindEvent = false;
        document.body.removeEventListener('mousedown', _mouseDown);
        window.removeEventListener('resize', closePanel);
        window.removeEventListener('keydown', _keyDown);
    };
    const _keyDown = e => {
        if (active && viewRef.current.style.display !== 'none') {
            if (e.code === 'Escape') {
                closePanel();
            } else if (e.code === 'Space' && isCanControl) {
                e.stopPropagation();
                e.preventDefault();
                if (isLoadedRef.current) {
                    if (e.timeStamp - _keyDownTimeStamp > 50) {
                        // _triggerController(e, !_isPlay);
                        _triggerController();
                    }
                    _keyDownTimeStamp = e.timeStamp;
                }
            }
        }
    };

    const _onBeforeChange = useCallback(
        (value, progress) => {
            if (!isCanControl || !isLoadedRef.current) return;
            isPlayingBeforeSeekRef.current = isPlaying;
            isDraggingRef.current = true;
            if (isPlaying) {
                _pause();
            }
            _seek(progress);
            setProgress(progress);
        },
        [isPlaying, progress, isPlayingBeforeSeekRef, isCanControl, isLoadedRef],
    );
    const _onChange = useCallback(
        (value, progress) => {
            if (!isCanControl || !isLoadedRef.current) return;
            _seek(progress);
            setProgress(progress);
        },
        [isPlaying, progress, isPlayingBeforeSeekRef, isCanControl, isLoadedRef],
    );

    const _onAfterChange = useCallback(
        (value, progress) => {
            if (!isCanControl || !isLoadedRef.current) return;
            isDraggingRef.current = false;
            _seek(progress);
            if (progress >= 1) {
                _onEnded();
            } else if (isPlayingBeforeSeekRef.current) {
                _play();
            } else if (!isPlayingBeforeSeekRef.current) {
                _pause();
            }
        },
        [isPlaying, progress, isPlayingBeforeSeekRef, isCanControl, isLoadedRef],
    );

    const _pause = () => {
        if (!isCanControl || !isLoadedRef.current) return;
        setIsPlaying(false);
        _stopUpdateProgress();
        mediaRef?.current && mediaRef.current.pause();
    };

    const _play = () => {
        if (!isCanControl || !isLoadedRef.current) return;
        setIsPlaying(true);
        mediaRef?.current && mediaRef?.current.play();
        _startLoopUpdateProgress();
    };
    const _seek = progress => {
        if (!isCanControl || !isLoadedRef.current) return;
        let seekTime = progress * duration;
        if (timeData) {
            seekTime += timeData.startTime;
        }
        if (!isNaN(seekTime)) {
            mediaRef?.current && (mediaRef.current.currentTime = seekTime);
        }
    };

    /**
     * @description 点击播放或者停止
     * @param e
     * @param toggle
     * @private
     */
    const _triggerController = (e, toggle) => {
        if (e) {
            e.stopPropagation();
        }
        if (typeof toggle === 'undefined') {
            if (isPlaying) {
                _pause();
            } else {
                _play();
            }
        } else {
            if (toggle) {
                _play();
            } else {
                _pause();
            }
        }
    };
    const _startLoopUpdateProgress = () => {
        clearInterval(_timer);
        _timer = setInterval(() => {
            let currentTime = mediaRef?.current?.currentTime;
            if (timeData) {
                currentTime -= timeData.startTime;
            }
            let p = currentTime / duration;
            p = isNaN(p) ? 0 : p;
            p = p > 1 ? 1 : p;
            setProgress(p);
        }, 16.7);
    };
    const _stopUpdateProgress = () => {
        if (_timer) {
            clearInterval(_timer);
            _timer = null;
        }
    };

    const _onLoadStart = () => {
        setIsLoading(true);
        isLoadedRef.current = false;
        if (timeData) {
            mediaRef.current.currentTime = timeData.startTime;
        }
    };
    const _onTimeUpdate = () => {
        if (timeData && !isDraggingRef.current) {
            if (mediaRef.current.currentTime >= timeData.endTime) {
                mediaRef.current.currentTime = timeData.startTime;
                _pause();
                setProgress(0);
                _seek(0);
            } else if (mediaRef.current.currentTime < timeData.startTime) {
                mediaRef.current.currentTime = timeData.startTime;
            }
        }
        if (!active) {
            _pause();
        }
    };
    const _onLoadedData = () => {
        setIsLoading(false);
        isLoadedRef.current = true;
    };
    const _onError = () => {
        setIsLoading(false);
        setIsRetry(true);
        setUrl('');
        isLoadedRef.current = false;
    };
    const _onPlay = () => {
        setIsPlaying(true);
        _startLoopUpdateProgress();
    };
    const _onPause = () => {
        setIsPlaying(false);
        _stopUpdateProgress();
    };
    const _onEnded = () => {
        if (!isDraggingRef.current) {
            _pause();
            _seek(0);
            setProgress(0);
            setIsPlaying(false);
        }
    };
    const _imgLoadError = () => {
        setIsLoading(false);
        setIsRetry(true);
        setUrl('');
    };
    const _imgLoaded = e => {
        const { width, height } = e.target;
        setMediaSize({ width, height });
        setIsLoading(false);
    };
    const _refresh = useCallback(() => {
        setIsRetry(false);
        setUrl(mediaUrl);
    }, [mediaUrl]);

    const mediaRef = useMemo(() => {
        return mediaType === 'VIDEO' ? videoRef : audioRef;
    }, [mediaType, videoRef, audioRef]);
    const previewSize = useMemo(() => {
        if (mediaType === 'AUDIO') {
            return {
                width: 320,
                height: 320,
            };
        }
        const ratio = mediaSize.width / mediaSize.height;
        let w = 458;
        let h = 256;
        if (ratio > 21 / 9) {
            w = 458;
            h = 256;
        } else if (ratio >= 16 / 9) {
            w = 458;
            h = w / ratio;
        } else if (ratio >= (1 + 16 / 9) / 2) {
            h = 256;
            w = h * ratio;
        } else if (ratio >= 1) {
            w = 380;
            h = w / ratio;
        } else if (ratio > (1 + 9 / 16) / 2) {
            h = 380;
            w = h * ratio;
        } else if (ratio >= 9 / 16) {
            w = 280;
            h = w / ratio;
        } else if (ratio >= 9 / 21) {
            h = 445;
            w = h * ratio;
        } else {
            h = 445;
            w = 280;
        }
        return { width: w, height: h };
    }, [mediaSize, mediaType]);

    const mediaStyle = useMemo(() => {
        const { width: pw, height: ph } = previewSize;
        return mediaSize.width / mediaSize.height >= pw / ph ? { width: '100%' } : { height: '100%' };
    }, [mediaSize, previewSize]);
    const boxStyle = useMemo(() => {
        let { width: w, height: h } = previewSize;
        w += 28;
        h += 28;
        if (isCanControl) {
            h += 25;
        }

        let toolPanelBarRect = document.querySelector('#fj-toolPanelBar')?.getBoundingClientRect
            ? document.querySelector('#fj-toolPanelBar')?.getBoundingClientRect()
            : {};
        let l = toolPanelBarRect.left + toolPanelBarRect.width;
        let t = toolPanelBarRect.top + toolPanelBarRect.height / 2 - h / 2;
        t = t < 20 ? 20 : t;
        if (position) {
            t = position.y - h / 2;
            l = position.x + 10;
            const windowHeight = document.body.clientHeight;
            const windowWidth = document.body.clientWidth;
            if (h + t > windowHeight) {
                t = windowHeight - h - 20;
            }
            if (w + l > windowWidth) {
                l = windowWidth - w - 20;
            }
        }
        const handlePixel = num => {
            //像素模糊问题处理
            if (Math.floor(num) % 2) {
                return Math.floor(num) - 1;
            } else {
                return Math.floor(num);
            }
        };

        return {
            transform: `translate(${handlePixel(l)}px, ${handlePixel(t)}px)`,
        };
    }, [mediaSize, previewSize, active, position]);
    const curTime = progress * duration;
    let currentTime = FJUtil.formatTime(curTime, true, 2, 1, true);
    let totalTime = FJUtil.formatTime(duration, true, 2, 1, true);
    const classes = {
        railClassName: styles.rail,
        trackClassName: styles.track,
        handleClassName: styles.handle,
        sliderBoxClassName: styles.slider,
    };
    const cn = classNames(styles.box, active ? styles.active : '');

    const getPreviewMedia = () => {
        if (url) {
            return mediaType === 'VIDEO' ? (
                <video
                    ref={videoRef}
                    className={styles.media}
                    src={url}
                    style={mediaStyle}
                    onLoadStart={_onLoadStart}
                    onLoadedData={_onLoadedData}
                    onError={_onError}
                    onEnded={_onEnded}
                    onPlay={_onPlay}
                    onTimeUpdate={_onTimeUpdate}
                    onPause={_onPause}
                    autoPlay
                    loading='lazy'
                />
            ) : mediaType === 'AUDIO' ? (
                <audio
                    onTimeUpdate={_onTimeUpdate}
                    src={url}
                    ref={audioRef}
                    className={styles.media_audio}
                    onLoadStart={_onLoadStart}
                    onLoadedData={_onLoadedData}
                    onError={_onError}
                    onEnded={_onEnded}
                    onPlay={_onPlay}
                    onPause={_onPause}
                    autoPlay
                />
            ) : (
                <img
                    className={styles.media}
                    src={url}
                    style={mediaStyle}
                    onError={_imgLoadError}
                    onLoad={_imgLoaded}
                    loading='lazy'
                    onDragStart={e => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                />
            );
        } else return null;
    };

    return (
        <div
            className={cn}
            style={boxStyle}
            ref={viewRef}
            data-auto-id='APP_Media_PreviewPIP'
            onMouseDown={e => {
                e.stopPropagation();
                e.preventDefault();
            }}
        >
            <div
                className={styles.preview}
                style={{ width: previewSize.width + 'px', height: previewSize.height + 'px' }}
                onClick={e => {
                    _triggerController(e);
                }}
            >
                {getPreviewMedia()}
                {mediaType === 'VIDEO' && !isPlaying && isLoadedRef.current ? (
                    <div className={styles.video_play}>
                        <VideoPlayIcon />
                    </div>
                ) : null}
                {isLoading ? (
                    <div className={styles.loading}>
                        <FJLoading />
                    </div>
                ) : null}
                {isRetry ? (
                    <div className={styles.reload} onClick={_refresh}>
                        <FJRetry refreshCallback={_refresh} isShow={true} />
                    </div>
                ) : null}
            </div>
            <div className={styles.control} style={{ display: isCanControl ? 'flex' : 'none' }}>
                <div onClick={e => _triggerController(e)} className={styles.play}>
                    {isPlaying ? <StopIcon /> : <PlayIcon />}
                </div>
                <div className={styles.progress}>
                    <FJSlider
                        progress={progress}
                        onBeforeChange={_onBeforeChange}
                        onChange={_onChange}
                        onAfterChange={_onAfterChange}
                        classes={classes}
                        isMobile={false}
                    />
                </div>
                <div className={styles.time}>
                    <span className={styles.currentTime}>{currentTime}</span>
                    <span className={styles.totalTime}>{' / ' + totalTime}</span>
                </div>
            </div>
        </div>
    );
};

FJMediaPreview.propTypes = {
    closePanel: PropTypes.func,
    mediaPreviewData: PropTypes.object,
};

export default FJMediaPreview;
